import i18next from 'i18next';

import { toastr } from 'react-redux-toastr';
import en_err from './locales/en/err.json';
import en_common from './locales/en/common.json';

import de_err from './locales/de/err.json';
import de_common from './locales/de/common.json';
import { isObject, difference } from 'underscore';

const storedLang = localStorage.getItem('system_language') || 'de';
i18next.init({
  lng: storedLang,
  fallbackLng: 'de',
  debug: false,
  returnNull: false,
  ns: ['common', 'err'],
  defaultNS: 'common',
  resources: {
    de: {
      common: de_common,
      err: de_err
    },
    en: {
      common: en_common,
      err: en_err
    }
  }
});

export const errorConfig = { closeOnToastrClick: true, timeOut: 0 };

interface ResponseData {
  err_id?: string;
  data?: {
    missing?: string;
  };
}

interface ToastrOptions {
  closeOnToastrClick?: boolean;
  timeOut?: number;
  [key: string]: any;
}
const toastError = (
  caption: string,
  response: ResponseData,
  toastr_options: ToastrOptions = {}
): void => {
  if (response.err_id && i18next.exists(response.err_id)) {
    if (response.data && response.data.missing) {
      response.data.missing = response.data.missing.replace('/', ' ');
    }
    toastr.error(i18next.t(caption), i18next.t(response.err_id, response.data), toastr_options);
  } else {
    toastr.error(i18next.t(caption), i18next.t('err:unknown'));
  }
};

function flatten(data: Record<string, any>): string[] {
  return Object.keys(data).reduce((acc: string[], key: string) => {
    if (isObject(data[key])) {
      return [...acc, ...flatten(data[key])];
    }
    return [...acc, key];
  }, []);
}

function showMissing(): void {
  const flatKeysDe = flatten(de_common);
  const flatKeysEn = flatten(en_common);
  const missingDE = difference(flatKeysEn, flatKeysDe);
  const missingEN = difference(flatKeysDe, flatKeysEn);

  if (missingDE.length) {
    console.warn('German common.json translations are missing some values');
    console.table(missingDE);
  }
  if (missingEN.length) {
    console.warn('English common.json translations are missing some values');
    console.table(missingEN);
  }
}

showMissing();

export { i18next, toastError };
